import { connect } from "react-redux";
import Programs from "./Programs";
import {
  getProgramsRequest,
  createProgramsRequest,
  updateProgramsRequest,
  deleteProgramsRequest,
} from "../../../store/actions/programs.actions";
import {
  programs,
  programsLoading,
  programLoading,
  programsPagination,
} from "../../../store/selectors/programs.selector";

const mapDispatchToProps = {
  getProgramsRequest,
  createProgramsRequest,
  updateProgramsRequest,
  deleteProgramsRequest,
};

const mapStateToProps = (state) => {
  const allPrograms = programs(state);
  const pageLoading = programsLoading(state);
  const loading = programLoading(state);
  const pagination = programsPagination(state);

  return { allPrograms, pageLoading, loading, pagination };
};

export default connect(mapStateToProps, mapDispatchToProps)(Programs);
